import { paramCase } from "change-case";

import { IFormantTheme } from "../style/IFormantTheme";

type ColorSets = keyof IFormantTheme["colors"];
type ColorKey<T extends ColorSets> = keyof IFormantTheme["colors"][T];

export const cssNamespace = "formant";

export const formantVariable = (...keys: string[]) =>
    `--${cssNamespace}-${keys.map(it => paramCase(it)).join("-")}`;

export const varColor = <TSet extends ColorSets, TKey extends ColorKey<TSet>>(
    colorSet: TSet,
    key: TKey,
) => `var(${formantVariable("color", colorSet, String(key))})`;

export const space = (value: 100 | 60 | 40 | 20 | 15 | 10 | 6 | 5 | 2) =>
    // FIXME resolve from theme when conversion to @emotion is complete
    // (props: { theme: IFormantTheme }) =>
    //     props.theme.spacing[`space${value}`];
    `${value / 16}rem`;
